/***
 * Created on 2025/2/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";

function IftttEmptyDevice(props) {
    const { t } = useTranslation();

    return (
        <div className="ifttt--login">
            <div className="ifttt--login__subtitle">{t('@Choose from the list of accessible devices below to log in and grant access to {app_name}:@', {
                app_name: 'IFTTT',
                interpolation: {
                    prefix: '{',
                    suffix: '}',
                    escapeValue: false
                }
            })}</div>
            <div className="common-info-grid common-info-grid--no-device">
                <p className="!mb-0 text-note">{t('@No device found.@')}</p>
            </div>
            <div className="mt-16"><a href="#">{t('@Sign in with a different account@')}</a></div>
        </div>
    );
}

export default IftttEmptyDevice;